import { useEffect } from 'react'
import styled from 'styled-components'

const Container = styled.div`
  flex: 1 0 auto;
  text-align: center;
  margin-top: 7rem;
`
const ScheduledMaintenanceImage = styled.img`
  width: 25%;
  height: 25%;
  @media screen and (max-width: 600px) {
    width: 0%;
    height: 0%;
    }
  }`

const MainMessage = styled.h2`
  margin: 0;
  padding: 20px;
`

const LineElement = styled.hr`
  margin-bottom: 1rem;
  border: 0;
  border-top: 1px solid rgba(0,0,0,.1);
  width: 50%;
  @media screen and (max-width: 600px) {
    width: 80%;
  }
`
const Close = styled.a`
  color: #004257;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
  font-family:
    NeueHaasUnica,
    -apple-system,system-ui,
    BlinkMacSystemFont,
    Segoe UI,
    Roboto,
    Helvetica Neue,Arial,sans-serif;
  font-size: 1.125rem;
  font-weight: 400;
  line-height: 1.33333333;
`

const AvailabilityManager = () => {
  useEffect(() => {
    document.title ='File Uploads - Undergoing Maintenance'
  }, [])


  return (
    <Container style={{ textAlign: 'center' }}>
      <ScheduledMaintenanceImage alt="logo" src={`${window.travURI}img/error_Icon.png`} />
      <br />
      <MainMessage >
        File Uploads is undergoing maintenance.
        <br />Check back soon.
      </MainMessage>
      <LineElement />
      <p>
        <Close href="https://travelers.com">Close</Close>
      </p>
    </Container>
  )
}

export { AvailabilityManager }
